import { render, staticRenderFns } from "./OcrConfirmation.vue?vue&type=template&id=45160136&scoped=true&"
import script from "./OcrConfirmation.vue?vue&type=script&lang=js&"
export * from "./OcrConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./OcrConfirmation.vue?vue&type=style&index=0&id=45160136&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45160136",
  null
  
)

export default component.exports